if (!customElements.get('component-complete-the-look')) {
  customElements.define('component-complete-the-look', class CompleteTheLook extends HTMLElement {
    constructor() {
      super();
      this.props = {
        shopUrl: this.dataset.shopUrl,
        productsSource: this.dataset.productsSource,
        rebuyRecType: this.dataset.rebuyRecType,
        productId: this.dataset.productId,
        rebuyApiLimit: this.dataset.rebuyApiLimit,
        rebuyProductsApiUrl: this.dataset.rebuyProductsApiUrl,
        rebuyApiKey: this.dataset.rebuyApiKey,
        productShowLimit: this.dataset.productShowLimit,
        intent: this.dataset.intent,
        designMode: this.dataset.designMode === 'true'
      }
    }
    connectedCallback() {
      if (!this.props.designMode && this.props.productsSource == 'api') {
        this.fetchRecommendations(this.props.productId);
        document.addEventListener('update-pdp-sections', (event) => {
          this.fetchRecommendations(event.detail.productId);
        });
      } else if (!this.props.designMode && this.props.productsSource === 'rebuy_api') {
        this.fetchRebuyRecommendations(this.props.productId);
        document.addEventListener('update-pdp-sections', (event) => {
          this.fetchRebuyRecommendations(event.detail.productId);
        });
      }
    }
    fetchRecommendations(productId) {
      const productRecommendationsSection = this.querySelector('.js-template');
      fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=${this.props.productShowLimit}&section_id=complete-the-look-products&intent=${this.props.intent}`)
      .then(response => response.text())
      .then((text) => {
          if (text) {
            productRecommendationsSection.innerHTML = text;
            this.classList.remove('hidden');
          } else {
            this.classList.add('hidden');
          }
      }).catch((error) => {
        console.error(error);
        this.classList.add('hidden');
      });
    }
    fetchRebuyRecommendations(productId) {
      const queryParams = {
        limit: this.props.rebuyApiLimit,
        filter_oos: 'yes',
        context: 'default',
        key: this.props.rebuyApiKey
      }
      if (this.props.rebuyRecType === 'similar_products') {
        queryParams.shopify_product_ids = productId || this.props.productId;
      }
      this.querySelector('.js-template');
      fetch(`${this.props.rebuyProductsApiUrl}${this.props.rebuyRecType}?${new URLSearchParams(queryParams).toString()}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(async (response) => {
        if (response?.data?.length > 0) {
          Promise.all(response.data.map(product => this.processProduct.call(this, product)))
          .then((divs) => {
            const container = this.querySelector('.js-complete-the-look-container');
            const productRecommendations = document.createElement('div');
            container.innerHTML = '';
            divs.filter(div => div !== null).slice(0, this.props.productShowLimit).forEach(div => productRecommendations.appendChild(div));
            container.innerHTML = productRecommendations.innerHTML;
          })
          .catch(error => {
            console.error('An error occurred while processing the products:', error);
            this.remove();
          });
        } else {
          this.remove();
        }
      }).catch((error) => {
        console.error(error);
        this.remove();
      });
    }
    async processProduct(product) {
      if (product.status === 'active' && product.product_type !== 'Kit' && product.images?.length > 0 && product.handle) {
        const html = await this.getProductHTML(product.handle);
        const div = document.createElement('div');
        div.innerHTML = html;
        return div;
      }
      return null;
    }
    async getProductHTML(handle) {
      // Get product data
      let response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=complete-the-look-product`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.text();
      return response;
    }
  })
}

if (!customElements.get('component-complete-the-look-product')) {
  customElements.define('component-complete-the-look-product', class CompleteTheLookProduct extends HTMLElement {
    constructor() {
      super();
      this.state = {
        response: '',
        trueSize: '',
        selectedVariantId: null,
        selectedVariant: null
      }
      this.props = {
        url: this.dataset.url
      }
      this.dom = {
        parentComponent: this.closest('component-complete-the-look'),
      }
      this.props.useTrueSize = this.dom.parentComponent?.dataset.useTrueSize === 'true';
    }
    connectedCallback() {
      this.renderCompleteTheLook();
    }
    async renderCompleteTheLook() {
      const response = await fetch(`${this.props.url}${this.props.url.includes('?') ? '&' : '?'}view=complete-the-look-json&currency=${window.Shopify.currency.active}&country=${window.Shopify.country}`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      this.state.response = await response.json();
      this.renderSizes();
      this.handleSizeSelection();
      this.handleAddToBag();
    }
    async setTrueSize() {
      const isUnderwear = this.state.response.type === 'Panties';
      const trueSize = await getTrueSize();
      if (trueSize) {
        this.state.trueSize = isUnderwear ? trueSize.underwear_size : `${trueSize.bra_band}${trueSize.bra_cup}`;
      }
    }
    async renderSizes() {
      if (this.props.useTrueSize) {
        await this.setTrueSize();
      }
      const availableSizes = this.state.response.availableSizes;
      const sizes = Object.keys(this.state.response.variants);
      for (let size of sizes) {
        let trueSize = this.state.trueSize;
        const option = document.createElement('option');
        option.value = size;
        option.textContent = size;
        if (this.state.response.type != 'Panties') {
          if (this.state.response.tags.includes("precise_sizing")) {
            trueSize = getMappedFormfitSize(trueSize);
          } else if (this.state.response.type !== "Bra" || this.state.response.tags.includes('alpha')) {
            trueSize = getMappedAlphaSize(trueSize);
          }
        }
        if (!availableSizes.includes(size)) {
          option.disabled = true;
          option.textContent = `${size} - SOLD OUT`;
        } else if (size === trueSize) {
          option.selected = true;
          this.state.selectedVariantId = this.state.response.variants[size].id;
        }
        this.querySelector('.js-sizes').appendChild(option);
      }
    }
    handleSizeSelection() {
      if (this.querySelector('.js-sizes')) {
        this.querySelector('.js-sizes').addEventListener('change', (event) => {
          const selectedSize = event.target.value;
          const variantId = this.state.response.variants[selectedSize]?.id;
          if (variantId) {
            this.state.selectedVariantId = variantId;
            this.state.selectedVariant = this.state.response.variants[selectedSize];
            this.querySelector('.js-add-to-bag-error').classList.add('hidden');
          }
        });
      }
    }
    handleAddToBag() {
      if (this.querySelector('.js-add-to-bag')) {
        this.querySelector('.js-add-to-bag').addEventListener('click', async (event) => {
          if (this.state.selectedVariantId) {
            event.preventDefault();

            try {
              this.querySelector('.js-add-to-bag').innerHTML = 'Adding to Cart';
              this.querySelector('.js-add-to-bag').classList.add('add-to-bag-btn--loading');
              const payload = {
                id: this.state.selectedVariantId,
                quantity: 1,
                properties: {
                  _tags: filterProductTags(this.state.response.tags)
                }
              };
              if (this.dom.parentComponent.props.productsSource === 'rebuy_api') {
                payload.properties._source = 'Rebuy';
                payload.properties._attribution = 'Rebuy Complete The Look';
              }
              const price = this.state.selectedVariant ? this.state.selectedVariant.price : this.state.response.price;
              const compareAtPrice = this.state.selectedVariant ? this.state.selectedVariant.compare_at_price : this.state.response.compare_at_price;
              if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
                payload.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
                payload.properties._compareAtPriceCa = compareAtPrice;
              } else if (compareAtPrice && compareAtPrice > price) {
                payload.properties._compareAtPrice = compareAtPrice;
                payload.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
              }
              
              if (window.cart_settings?.checkoutFinalSaleLabel && payload.properties._tags?.includes('__label: Final Sale')) {
                payload.properties['Final Sale'] = window.cart_settings.checkoutFinalSaleLabel;
              }

              await window.cartManager.addItem(payload);
              window.dispatchEvent(new CustomEvent('update-cart'));

              window.sendGTMData && window.sendGTMData({
                event: 'complete-the-look-item-added',
                page_location: window.location.href || null,
                customer_id: window.theme.customer.id || null,
                product_id: window.cartManager.getLocalCart().items.filter((pd) => pd.id === this.state.selectedVariantId)[0]?.product_id,
                variant_id: this.state.selectedVariantId
              });

              this.querySelector('.js-add-to-bag').classList.remove('add-to-bag-btn--loading');
              this.querySelector('.js-add-to-bag-error').classList.add('hidden');
              this.querySelector('.js-add-to-bag').innerHTML = 'Add to Cart';
            } catch (err) {
              this.querySelector('.js-add-to-bag-error').textContent = 'Sorry, please try again later';
              this.querySelector('.js-add-to-bag-error').classList.remove('hidden');
            }
          } else {
            this.querySelector('.js-add-to-bag-error').textContent = 'Select a size';
            this.querySelector('.js-add-to-bag-error').classList.remove('hidden');
          }
        });
      }
    }
  });
}
